interface Environment {
  apiUrl: string;
  environment: string;
  isDevelopment: boolean;
  isProduction: boolean;
  isStaging: boolean;
}

const createEnvironment = (): Environment => {
  const apiUrl = import.meta.env.VITE_API_URL || 'http://localhost:3000';
  const environment = import.meta.env.VITE_ENVIRONMENT || 'development';

  return {
    apiUrl,
    environment,
    isDevelopment: environment === 'development',
    isProduction: environment === 'production',
    isStaging: environment === 'staging',
  };
};

export const env = createEnvironment();

// Log environment info in development
if (env.isDevelopment) {
  console.log('Environment configuration:', {
    apiUrl: env.apiUrl,
    environment: env.environment,
  });
}
